import React from 'react';
import classNames from "classnames";

import Framework from "@beardeddevops/react.framework"
import {Objects} from "components";

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

const breadcrumbsStatic = [{
	name: 'Feedback Zone',
	url: '/regions/feedback_zone',
	icon: 'map',
}];

export default class Region extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');

		this.state = {
			...this.state,
			name: '',
		}
	}

	handleData = (data) => {
		this.setState({name: data.name});
	}

	render() {
		let {match, history, baseUrl, reloadShell} = this.props;
		console.log("we somehow are making it here")

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={history}/>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Region" value="details"/>
				</Tabs>

				<div className={classNames({'hidden': this.state.tab !== 'details'})}>
				  <Objects.FeedbackZone
						id={match.params.id}
						parent={match.params.id}
						history={history}
						onData={this.handleData}
						reloadShell={reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						baseUrl={baseUrl + "/feedback_list"}
						goBack={true}
					/>
				</div>

			</div>
		)
	}
};